/* Synouvelle Produktseite: Umschalter im Vergleich (Handy), feste Kaufleiste, Zähler. Das Blättern in der Galerie läuft über CSS. */
(function () {
  function initLeiste() {
    var leiste = document.querySelector('[data-syn-leiste]');
    var ziel = document.querySelector('.syn-kauf__aktion');
    if (!leiste || !ziel || !('IntersectionObserver' in window)) return;
    leiste.hidden = false;
    leiste.setAttribute('inert', '');
    var handy = window.matchMedia('(max-width: 749px)');
    var wurzel = document.documentElement;
    var zielSichtbar = true;
    var zielOben = false;
    var gescrollt = false;
    /* Handy: sobald gescrollt wurde und der eigentliche Button nicht zu sehen ist. Laptop: erst nach dem Scrollen über den Button.
       Nie, solange der Cookie-Banner offen ist (syn-cookie 27.10.2026). */
    function pruefen() {
      var zeigen = !zielSichtbar && (handy.matches ? gescrollt : zielOben) && !wurzel.classList.contains('syn-cookie-offen');
      leiste.classList.toggle('ist-sichtbar', zeigen);
      if (zeigen) leiste.removeAttribute('inert');
      else leiste.setAttribute('inert', '');
    }
    new IntersectionObserver(function (eintraege) {
      var e = eintraege[0];
      zielSichtbar = e.isIntersecting;
      zielOben = e.boundingClientRect.top < 0;
      pruefen();
    }, { threshold: 0 }).observe(ziel);
    function beimScrollen() {
      if (window.scrollY > 80) {
        gescrollt = true;
        window.removeEventListener('scroll', beimScrollen);
        pruefen();
      }
    }
    window.addEventListener('scroll', beimScrollen, { passive: true });
    beimScrollen();
    document.addEventListener('syn:cookie', pruefen);
  }

  function initZaehler(zaehler) {
    var liste = zaehler.previousElementSibling;
    if (!liste) return;
    var gesamt = parseInt(zaehler.getAttribute('data-syn-zaehler'), 10) || 1;
    var aktuell = zaehler.querySelector('[data-syn-zaehler-aktuell]');
    var zurueck = zaehler.querySelector('.syn-zaehler__knopf--zurueck');
    var weiter = zaehler.querySelector('.syn-zaehler__knopf--weiter');
    zaehler.hidden = false;
    function schritt() {
      var karte = liste.firstElementChild;
      if (!karte) return liste.clientWidth;
      var abstand = karte.nextElementSibling ? karte.nextElementSibling.offsetLeft - karte.offsetLeft : karte.offsetWidth;
      return abstand || liste.clientWidth;
    }
    function stand() {
      var max = liste.scrollWidth - liste.clientWidth;
      var n = liste.scrollLeft >= max - 2 ? gesamt : Math.min(gesamt, Math.round(liste.scrollLeft / schritt()) + 1);
      aktuell.textContent = n;
      zurueck.disabled = n <= 1;
      weiter.disabled = n >= gesamt;
    }
    liste.addEventListener('scroll', function () { window.requestAnimationFrame(stand); }, { passive: true });
    zurueck.addEventListener('click', function () { liste.scrollBy({ left: -schritt(), behavior: 'smooth' }); });
    weiter.addEventListener('click', function () { liste.scrollBy({ left: schritt(), behavior: 'smooth' }); });
    stand();
  }

  /* Vergleich am Handy: Umschalter und wischbare Karten bleiben synchron.
     Die schwarze Marke folgt stufenlos der Wischbewegung, die Schrift wechselt weich die Farbe. */
  function initVgm(box) {
    var bahn = box.querySelector('[data-syn-vgm-bahn]');
    var schalter = box.querySelector('.syn-vgm__schalter');
    var knoepfe = box.querySelectorAll('[data-syn-vgm-knopf]');
    if (!bahn || !schalter || !knoepfe.length) return;
    var gewaehlt = 0;
    function markieren(i) {
      if (i === gewaehlt) return;
      gewaehlt = i;
      knoepfe.forEach(function (k, j) { k.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
    }
    function lage() {
      var breite = bahn.clientWidth || 1;
      var pos = Math.max(0, Math.min(knoepfe.length - 1, bahn.scrollLeft / breite));
      schalter.style.setProperty('--syn-pos', pos.toFixed(4));
      markieren(Math.round(pos));
    }
    knoepfe.forEach(function (k, i) {
      k.addEventListener('click', function () {
        bahn.scrollTo({ left: i * bahn.clientWidth, behavior: 'smooth' });
      });
    });
    bahn.addEventListener('scroll', function () { window.requestAnimationFrame(lage); }, { passive: true });
    lage();

    /* Abstand zur nächsten Sektion richtet sich nach der ersten Karte. Längere Karten dürfen in den Abstand
       hineinragen, es bleiben aber immer mindestens 40 px (Mario 13.10.2026). */
    var MINDEST = 40;
    function ausgleich() {
      box.style.marginBottom = '';
      var erste = bahn.firstElementChild;
      if (!erste || !box.offsetParent) return;
      var ueberhang = bahn.clientHeight - erste.offsetHeight;
      var sektion = box.closest('.shopify-section');
      var naechste = sektion && sektion.nextElementSibling;
      var ziel = naechste && (naechste.querySelector('.syn-sektion') || naechste.firstElementChild);
      if (ueberhang <= 0 || !ziel) return;
      var abstand = ziel.getBoundingClientRect().top - bahn.getBoundingClientRect().bottom;
      var weniger = Math.max(0, Math.min(ueberhang, abstand - MINDEST));
      if (weniger > 0) box.style.marginBottom = (-Math.round(weniger)) + 'px';
    }
    if ('ResizeObserver' in window) {
      var beobachter = new ResizeObserver(function () { window.requestAnimationFrame(ausgleich); });
      Array.prototype.forEach.call(bahn.children, function (k) { beobachter.observe(k); });
      beobachter.observe(bahn);
    } else {
      window.addEventListener('resize', ausgleich);
      window.addEventListener('load', ausgleich);
    }
    ausgleich();
  }

  /* Klappfelder (FAQ, Kaufbereich): weich auf- und zuklappen statt springen (Mario 13.10.2026) */
  var leise = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initKlapp(d) {
    var kopf = d.querySelector('summary');
    var inhalt = kopf && kopf.nextElementSibling;
    if (!kopf || !inhalt || !d.animate) return;
    var lauf = null, aus = null;
    var DAUER = 460, KURVE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
    function fertig() {
      lauf = null;
      d.style.height = '';
      d.style.overflow = '';
      d.classList.remove('syn-schliesst');
    }
    kopf.addEventListener('click', function (e) {
      if (leise.matches) return;
      e.preventDefault();
      var start = d.offsetHeight + 'px';
      if (lauf) lauf.cancel();
      if (aus) { aus.cancel(); aus = null; }
      d.style.overflow = 'hidden';
      if (!d.open || d.classList.contains('syn-schliesst')) {
        d.classList.remove('syn-schliesst');
        d.style.height = start;
        d.open = true;
        var ziel = (kopf.offsetHeight + inhalt.offsetHeight) + 'px';
        lauf = d.animate({ height: [start, ziel] }, { duration: DAUER, easing: KURVE });
        inhalt.animate({ opacity: [0, 1], transform: ['translateY(-6px)', 'none'] }, { duration: DAUER, easing: KURVE });
        lauf.onfinish = fertig;
        lauf.oncancel = function () { lauf = null; };
      } else {
        d.classList.add('syn-schliesst');
        lauf = d.animate({ height: [start, kopf.offsetHeight + 'px'] }, { duration: DAUER - 60, easing: KURVE });
        aus = inhalt.animate({ opacity: [1, 0] }, { duration: DAUER - 160, easing: 'ease-out', fill: 'forwards' });
        lauf.onfinish = function () { d.open = false; if (aus) { aus.cancel(); aus = null; } fertig(); };
        lauf.oncancel = function () { lauf = null; };
      }
    });
  }


  /* Merkt, ob der Shopify-Cookie-Banner offen ist (Klasse syn-cookie-offen am html), damit die Kaufleiste bis zur Entscheidung verborgen bleibt. */
  function initCookieBeobachter() {
    var wurzel = document.documentElement;
    var banner = null;
    var attribute = new MutationObserver(pruefen);
    function pruefen() {
      var offen = !!(banner && banner.isConnected && getComputedStyle(banner).display !== 'none');
      if (offen !== wurzel.classList.contains('syn-cookie-offen')) {
        wurzel.classList.toggle('syn-cookie-offen', offen);
        document.dispatchEvent(new CustomEvent('syn:cookie'));
      }
    }
    function suchen() {
      var b = document.getElementById('shopify-pc__banner');
      if (b && b !== banner) {
        banner = b;
        attribute.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
      pruefen();
    }
    new MutationObserver(suchen).observe(document.body, { childList: true });
    suchen();
  }

  function start() {
    document.querySelectorAll('details.syn-fragen__eintrag, details.syn-klapp__eintrag').forEach(initKlapp);
    document.querySelectorAll('[data-syn-vgm]').forEach(initVgm);
    document.querySelectorAll('[data-syn-zaehler]').forEach(initZaehler);
    initCookieBeobachter();
    initLeiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
